"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AuditIntroduction() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="audit-introduction" className="relative bg-[rgb(0,24,41)] text-secondary-foreground py-[60px] border-y border-primary/30 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle,rgba(181,166,66,0.05)_0%,transparent_70%)]" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out flex flex-col items-center ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-5xl md:text-[72px] leading-none font-black uppercase tracking-tight text-secondary-foreground">&nbsp;&nbsp;<br /><span className="text-[rgb(167,181,190)]" data-ast-id="f:/src/pages/OperationalAudit/sections/AuditIntroduction.tsx|sig:tglcb" data-ast-start="1103" data-ast-end="1290">OPERATIONAL</span> <span className="text-[rgb(186,174,94)]" data-ast-id="f:/src/pages/OperationalAudit/sections/AuditIntroduction.tsx|sig:rpjjxa" data-ast-start="1291" data-ast-end="1477">DIAGNOSTIC</span></h2>
          {}
          <div className="h-[1px] w-full bg-primary mt-6 mb-8 shadow-[0_0_10px_rgba(var(--primary),0.5)]" aria-hidden="true" />
        </div>

        <div ref={textRef} className={`transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-sans text-xl md:text-[24px] text-secondary-foreground/80 max-w-4xl mx-auto font-light tracking-widest uppercase">
            Initiating systematic evaluation of core processes, mechanical
            tolerances, and efficiency metrics. Awaiting input parameters.
          </p>
        </div>
      </div>
    </section>;
}